<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>Needs attention
      <v-chip v-if="items.length" small class="ml-2">{{ items.length }}</v-chip>
    </v-card-title>
    <v-card-text>
      <div v-if="!items.length" class="caption grey--text">Nobody needs attention.</div>
      <div v-for="i in visible" :key="i.user_id" class="d-flex align-center py-1 attention-row" @click="$emit('select', i.user_id)">
        <span class="body-2 font-weight-medium mr-2">{{ i.name }}</span>
        <v-chip v-for="r in i.reasons" :key="r" x-small outlined class="mr-1" :color="color(r)">{{ label(r) }}</v-chip>
      </div>
      <v-btn v-if="items.length > limit" small text class="text-none mt-1" @click="showAll = !showAll">
        {{ showAll ? 'Show less' : 'Show all ' + items.length }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
const LABELS = {
  score_down: 'Score down',
  low_habits: 'Low habits',
  no_kpis: 'No KPIs',
  no_recognition: 'No recognition (30d)',
}
const COLORS = { score_down: 'error', low_habits: 'orange', no_kpis: 'primary', no_recognition: 'grey' }

export default {
  name: 'AdminAttentionPanel',
  props: { items: { type: Array, default: () => [] } },
  data() {
    return { showAll: false, limit: 8 }
  },
  computed: {
    visible() {
      return this.showAll ? this.items : this.items.slice(0, this.limit)
    },
  },
  methods: {
    label(r) { return LABELS[r] || r },
    color(r) { return COLORS[r] || 'grey' },
  },
}
</script>

<style scoped>
.attention-row { cursor: pointer; flex-wrap: wrap; }
</style>
